import ChartDataLabels from 'chartjs-plugin-datalabels'
import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Bar } from 'react-chartjs-2'
import { useSelector } from 'react-redux'
import Activity from '../components/Activity'
import { useGetAggregatesQuery, useGetCategoriesQuery } from '../redux/api/aggregateApi'

const Aggregate = () => {
  const [sortBy, setSortBy] = useState()
  const [search, setSearch] = useState('')

  const { isGroup } = useSelector((state) => state.user)

  const { data: categories, isLoading: isLoadingCategories } = useGetCategoriesQuery()
  const { data, isLoading, isError, error } = useGetAggregatesQuery({ isGroup })

  if (isLoading || isLoadingCategories || !categories) return <p>Loading...</p>
  if (isError) return <p>{error.message}</p>

  const sortedData = [...data].sort((a, b) => {
    const average = (obj) =>
      Object.values(obj.chart)
        .filter((v) => v > 0)
        .reduce((prev, curr, _, arr) => prev + curr / arr.length, 0)

    const x = average(a)
    const y = average(b)

    return y - x
  })

  sortedData?.sort((a, b) => {
    if (a.chart[sortBy] === undefined && b.chart[sortBy] === undefined) return 0
    else if (a.chart[sortBy] === undefined) return 1
    else if (b.chart[sortBy] === undefined) return -1
    else return b.chart[sortBy] - a.chart[sortBy]
  })

  const charts = search ? sortedData?.filter((d) => d.name.toLowerCase().includes(search.toLowerCase())) : sortedData

  const reset = () => {
    setSortBy('')
  }

  return (
    <div>
      <div className='dashboard-heading'>
        <div className='content-container'>
          <h2>Aggregate</h2>
          <p>Aggregate data of all</p>
        </div>
        <Activity />
      </div>

      <div className='d-flex align-items-end justify-content-between'>
        <div className='chips-container mt-4'>
          <span>Sort By</span>

          <ul className='chips-ul'>
            <button className='common-btn rounded-pill px-4 py-2' onClick={reset}>
              Reset
            </button>
            {Object.values(categories)?.map((category, i) => {
              return (
                <li key={i} className={sortBy === category ? 'active' : ''} onClick={() => setSortBy(category)}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    className='feather feather-check'
                  >
                    <path d='M20 6 9 17l-5-5' />
                  </svg>
                  {category}
                </li>
              )
            })}
          </ul>
        </div>
        <div className=''>
          <input type='text' placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
      </div>

      <Row>
        {charts && charts.length > 0 ? (
          charts.map(({ name, chart }, i) => {
            return (
              <Col lg={6} xxl={4} key={i}>
                <div className='dashboard-cards stat-container'>
                  <div className='performance-heading'>
                    <div className='performance-content'>
                      <h4 className='text-black'>{name}</h4>
                    </div>
                  </div>
                  <Bar
                    plugins={[ChartDataLabels]}
                    data={{
                      labels: Object.keys(chart).map((k) => k.charAt(0).toUpperCase() + k.slice(1)),
                      datasets: [
                        {
                          data: Object.values(chart),
                          backgroundColor: bgColors,
                          barPercentage: 0.5,
                          barThickness: 40,
                          maxBarThickness: 50,
                          borderRadius: 8,
                          minBarLength: 2,
                        },
                      ],
                    }}
                    options={options}
                  />
                </div>
              </Col>
            )
          })
        ) : (
          <Col md={4}>
            <div className='dashboard-cards'>
              <h2>No Results</h2>
            </div>
          </Col>
        )}
      </Row>
    </div>
  )
}

export default Aggregate

const bgColors = ['#c8d1fc', '#b3ddf6', '#95d8a5', '#c5e49e', '#fedf6b', '#eea08c', '#B7A1C7']

const options = {
  layout: {
    padding: {
      top: 30,
    },
  },
  plugins: {
    tooltip: {
      enabled: false,
    },
    legend: {
      display: false,
    },
    datalabels: {
      labels: {
        value: {
          anchor: 'end',
          align: 'top',
          display: true,
          color: 'black',
          font: {
            weight: 'bold',
            size: 16,
          },
          offset: 0,
          formatter: (value, ctx) => {
            return value
          },
        },
      },
    },
  },

  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
      min: 0,
      max: 100,
    },
  },
}
